import { render, staticRenderFns } from "./GeralCandidatoRecursoComponent.vue?vue&type=template&id=310022d8&scoped=true&"
import script from "./GeralCandidatoRecursoComponent.vue?vue&type=script&lang=js&"
export * from "./GeralCandidatoRecursoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310022d8",
  null
  
)

export default component.exports